import { z, ZodError } from "zod/v4";

function parseErrorObjectToString(errorObject: any) {
    if (typeof errorObject === "string") return errorObject;
    if (errorObject instanceof ZodError) return errorObject.message;
    if ("message" in errorObject) return errorObject.message as string;
    return "El valor no es válido";
}

export function handleErrorMessage(errorList: any[]) {
    const hasError = Boolean(errorList.length);
    const unique = [...new Set(errorList.map(parseErrorObjectToString).filter(Boolean))];
    const errors = hasError ? unique.join(", ") : "";

    return [hasError, errors ? errors + "." : ""] as [boolean, string];
}

export function handleFormErrorMessage(key: string, errors: (Record<string, any[]> | undefined)[]) {
    const errorList = [] as any[];

    errors.forEach(em => {
        if (!em) return;
        if (!(key in em)) return;
        const el = em[key];
        errorList.push(...el);
    })

    return handleErrorMessage(errorList)
}


export function getDefaultValueFromSchema<TSchema extends z.ZodType>(schema: TSchema): z.input<TSchema> {
    //Null and Undefined
    if (schema instanceof z.ZodDefault) return schema.def.defaultValue;
    if (schema instanceof z.ZodNullable) return null;
    if (schema instanceof z.ZodOptional) return undefined;

    //Primitive types
    if (schema instanceof z.ZodString || schema instanceof z.ZodStringFormat) return "";
    if (schema instanceof z.ZodNumber) return "" as unknown as number;
    if (schema instanceof z.ZodBoolean) return false;

    //Array
    if (schema instanceof z.ZodArray) return [];

    //Record
    if (schema instanceof z.ZodRecord) return {};

    //Object
    if (schema instanceof z.ZodObject) {
        return Object.fromEntries(Object.entries(schema.shape).map(([key, value]) => {
            return [key, getDefaultValueFromSchema(value as any)];
        }))
    }

    //Union | Intersections (defaults to "")
    if (schema instanceof z.ZodUnion) return "";
    if (schema instanceof z.ZodIntersection) return "";

    //Transform
    if (schema instanceof z.ZodPipe) return getDefaultValueFromSchema(schema.def.in as any);

    throw new Error("Unsupported default zod schema type.");
}
